import CallStatusBadgeComponent from './CallStatusBadge.component';

export * from './CallStatusBadge.component';
export default CallStatusBadgeComponent;
